import { colors } from "buoy-theme"
import styled, { keyframes } from "styled-components"

const BounceUp = keyframes`
    0% { transform: translate3d(0, 300%, 0) }
    58% { transform: translate3d(0, -27px, 0) }
    73% { transform: translate3d(0, 12px, 0) }
    88% { transform: translate3d(0, -8px, 0) }
`

const PopUpContainer = styled.div`
  position: fixed;
  bottom: -100px;
  width: 100%;
  background: ${colors.primary};
  padding: 0 22px 0 22px;
  border-top: 2px solid ${colors.primary};
  z-index: 9999;
  overflow: auto;
  min-height: ${props => (props.response ? "550px" : "435px")};

  display: flex;
  justify-content: center;

  animation: ${BounceUp} 2s ease;

  @media (min-width: 640px) {
    min-height: ${props => (props.response ? "450px" : "350px")};
  }
`

export default PopUpContainer



// WEBPACK FOOTER //
// ./assets/feedback/components/postIntent/components/PopUpContainer.js